/* global Swiper */

export default {
  init() {
    const roomsSliderBlock = $('.rooms-slider-block');
    if (roomsSliderBlock.length) {
      const swiperContainer = roomsSliderBlock.find('.rooms-slider-swiper-container').get(0);

      if (swiperContainer) {
        let mediaMaxWidth = window.matchMedia('(max-width: 767px)');
        new Swiper(swiperContainer, {
          grabCursor: true,
          centeredSlides: true,
          spaceBetween: 0,
          slidesPerView: 'auto',
          speed: 700,
          navigation: {
            nextEl: '.rooms-slider-swiper-button-next',
            prevEl: '.rooms-slider-swiper-button-prev',
          },
          pagination: {
            el: '.rooms-slider-swiper-pagination',
            type: mediaMaxWidth.matches ? 'progressbar' : 'fraction',
            clickable: mediaMaxWidth.matches,
          },
          onAny(eventName) {
            if(eventName === 'transitionEnd') {
              const swiperSlideActive = $('.swiper-slide-active');
              swiperSlideActive.each(function() {
                if($(this).data('room-index') != undefined) {
                  let roomSliderActiveHeaderText = $('#rooms-slider-active-header-text');
                  roomSliderActiveHeaderText.html($(this).data('room-title'));
                  roomSliderActiveHeaderText.attr('href', $(this).data('room-link'));
                  let roomSliderActiveDescriptionText = $('#rooms-slider-active-description-text');
                  roomSliderActiveDescriptionText.html($(this).data('room-description'));
                }
              });
            }
          },
        });
      }
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/roomsSlider.js